import { ONBOARDING_STAGES } from "@/data/onboardingData";
import { DataPointList } from "./DataPointList";
import { VisualDiagram } from "./VisualDiagram";
import { StepLayout } from "./StepLayout";
import solarRooftopDiagram from "@/assets/solar-rooftop-diagram.png";

interface SalesStepProps {
  selectedKeys: Set<string>;
  onToggle: (key: string) => void;
  onRequestMissing: () => void;
}

export function SalesStep({ selectedKeys, onToggle, onRequestMissing }: SalesStepProps) {
  const stage = ONBOARDING_STAGES.find(s => s.id === "sales")!;
  return (
    <div className="space-y-4 pb-20">
      <div className="space-y-1">
        <h2 className="text-2xl font-semibold">{stage.heading}</h2>
        <p className="text-muted-foreground">{stage.subHeading}</p>
      </div>
      <StepLayout
        dataCount={stage.dataPoints.length}
        visual={
          <VisualDiagram
            diagramLabel="Rooftop Solar Design"
            dataPoints={stage.dataPoints}
            selectedKeys={selectedKeys}
            onToggle={onToggle}
            imageSrc={solarRooftopDiagram}
          />
        }
        list={
          <DataPointList
            dataPoints={stage.dataPoints}
            selectedKeys={selectedKeys}
            onToggle={onToggle}
            onRequestMissing={onRequestMissing}
          />
        }
      />
    </div>
  );
}
